<div class="motors-listing-details-header-section">
    <form novalidate #motorsListingDetailsHeaderSectionForm="ngForm">
        <tg-row flexContents>
            <tg-col lg="4" md="6" sm="12">
                <tg-card
                    class="motors-listing-details-header-section__card"
                    bordered
                    [ngClass]="{
                        'motors-listing-details-header-section__card--selected':
                            selectedSellingType === SellingTypeEnum.classified, selectionInvalid: sellingTypeInvalid
                    }"
                    (click)="setSellingType(SellingTypeEnum.classified)"
                >
                    <tg-row>
                        <tg-col>
                            <label
                                class="motors-listing-details-header-section__card__input-container"
                            >
                                Set an asking price
                                <input
                                    type="radio"
                                    name="sellingType"
                                    [value]="SellingTypeEnum.classified"
                                    [(ngModel)]="
                                        draftData.listingDetails.sellingType
                                    "
                                />
                                <span class="checkmark"></span>
                            </label>
                        </tg-col>
                    </tg-row>
                    <tg-row>
                        <tg-col>
                            <ul tgList2 type="bullet" class="list">
                                <li>Negotiate on price directly with buyers</li>
                                <li>Ability to accept ‘Or near offers’</li>
                            </ul>
                        </tg-col>
                    </tg-row>
                </tg-card>
            </tg-col>
            <tg-col lg="4" md="6" sm="12">
                <tg-card
                    class="motors-listing-details-header-section__card"
                    bordered
                    [ngClass]="{
                        'motors-listing-details-header-section__card--selected':
                            selectedSellingType === SellingTypeEnum.auction, selectionInvalid: sellingTypeInvalid
                    }"
                    (click)="setSellingType(SellingTypeEnum.auction)"
                >
                    <tg-row>
                        <tg-col>
                            <label
                                class="motors-listing-details-header-section__card__input-container"
                            >
                                Run an auction
                                <input
                                    type="radio"
                                    name="sellingType"
                                    [value]="SellingTypeEnum.auction"
                                    [(ngModel)]="
                                        draftData.listingDetails.sellingType
                                    "
                                />
                                <span class="checkmark"></span>
                            </label>
                        </tg-col>
                    </tg-row>
                    <tg-row>
                        <tg-col>
                            <ul tgList2 type="bullet" class="list">
                                <li>The fastest way to sell your boat</li>
                                <li>Get a fair market price </li>
                                <li>Set a reserve price</li>
                            </ul>
                        </tg-col>
                    </tg-row>
                </tg-card>
            </tg-col>
        </tg-row>
        <tg-row>
            <tg-col>
                <label class="motors-listing-details-header-section__view-price-options">
                    View our <a href="https://help.trademe.co.nz/hc/en-us/articles/360032010952-Motors-fees#h_5872a85f-8c57-41ae-9768-d399809eb5a5" target="_blank">listing options and prices</a>.
                </label>
            </tg-col>
        </tg-row>
    </form>
</div>
